// extracted by mini-css-extract-plugin
export var cardCarousel = "card-carousel-module--card-carousel--e018d";
export var cardCarouselMosaic = "card-carousel-module--card-carousel--mosaic--b3352";
export var cardCarousel__body = "card-carousel-module--card-carousel__body--1e84c";
export var cardCarousel__carousel = "card-carousel-module--card-carousel__carousel--cab99";
export var cardCarousel__splide = "card-carousel-module--card-carousel__splide--a4fb6";
export var cardCarousel__splide__actions = "card-carousel-module--card-carousel__splide__actions--44360";
export var cardCarousel__splide__arrow = "card-carousel-module--card-carousel__splide__arrow--116a5";
export var cardCarousel__splide__arrowIcon = "card-carousel-module--card-carousel__splide__arrow-icon--5113c";
export var cardCarousel__splide__arrowNext = "card-carousel-module--card-carousel__splide__arrow--next--d1243";
export var cardCarousel__splide__arrowPrev = "card-carousel-module--card-carousel__splide__arrow--prev--7dcfd";
export var cardCarousel__splide__card = "card-carousel-module--card-carousel__splide__card--53aee";
export var cardCarousel__splide__pagination = "card-carousel-module--card-carousel__splide__pagination--7f3ea";
export var cardCarousel__splide__slide = "card-carousel-module--card-carousel__splide__slide--20070";
export var cardCarousel__splide__track = "card-carousel-module--card-carousel__splide__track--ffb9c";
export var cardCarousel__title = "card-carousel-module--card-carousel__title--82744";
export var mt0 = "card-carousel-module--mt-0--2f2e2";
export var mt1 = "card-carousel-module--mt-1--64f54";
export var mt2 = "card-carousel-module--mt-2--542b7";
export var mt3 = "card-carousel-module--mt-3--92f29";
export var mt4 = "card-carousel-module--mt-4--8f053";
export var mt5 = "card-carousel-module--mt-5--71ef1";
export var mt6 = "card-carousel-module--mt-6--270ea";